import { useRef } from 'react';

/**
 * Custom hook per utilizzare la forwardRef se definita o una ref locale al componente.
 */
function useForwardRefOrRef(forwardedRef) {
    const ref = useRef(null);
    const refCallback = (instance) => {
        ref.current = instance;
        if (typeof forwardedRef === 'function') {
            forwardedRef(instance);
        }
        else if (forwardedRef) {
            // eslint-disable-next-line no-param-reassign
            forwardedRef.current = instance;
        }
    };
    return [refCallback, ref];
}

export { useForwardRefOrRef as default };
